export default [
  'viewConvertStepOverview', // done
  'viewConvertStepTerms', // done
  'viewConvertStepOnboarding', // done
  'viewConvertStepAddons', // done
  'viewConvertStepPayment', // done
  'viewConvertStepSuccess', // done
  'completedConvertStepTerms', // done
  'completedConvertStepOnboarding', // done
  'completedConvertStepAddons', // done

  'cancelPopupSavePhone', // done
  'cancelPopupSaveChat', // done
  'cancelPopupSaveEmail', // done
  'downgradeSaveChat',
  'downgradeSavePhone',
  'downgradeSaveEmail',

  'clickEditPlan', // ?
  'clickUpdateSubscription', // done
  'planChanged', // done
  'billingCycleChanged', // done
  'addonsChanged', // done
  'onboardingChanged', // done
  'increaseLicenses', // done
  'decreaseLicenses', // done
  'addCoupon', // done
  'clickCancel', // done
  'clickContinueToCancel', // done
  'clickPurchase', // done
  'clickEditPlanOnReviewPage',
  // editLicenses',
  // editBillingCycle',
  'editPaymentMethod', // done
  'editBillingAddress', // done
  // editBillingContact',

  'pauseAccount',
  'callUsAfterPausing', // done
  'undoAccountPause',
  'reactivateSubscription',
  'unpauseSubscription', // done
  'emailCustomerCareToCancelWhilePaused', // done

  'cancellationFlowScheduleFreeTraining', // done
  'cancellationFlowUserAppliesDiscount',
  'cancellationFlowUserDoesntTakeDiscount'
]
